export class QuestionBase<T> {
    value: T;
    key: string;
    label: string;
    rowcount: number;
    name: string;
    required: boolean;
    order: number;
    controlType: string;
    type: string;
    options: {key: string, value: string}[];
    pattern: string;
    input_type: string;
    maxDate:Date;
  
    constructor(options: {
        value?: T,
        key?: string,
        label?: string,
        rowcount?:number,
        name?:string,
        required?: boolean,
        order?: number,
        controlType?: string,
        type?: string
        options?: {key: string, value: string}[],
        pattern?: string,
        input_type?: string,
        maxDate?:Date
      } = {}) {
      this.value = options.value;
      this.key = options.key || '';
      this.label = options.label || '';
      this.rowcount = options.rowcount || 2;
      this.name = options.name || '';
      this.required = options.required || false;
      this.order = options.order === undefined ? 1 : options.order;
      this.controlType = options.controlType || '';
      this.type = options.type || '';
      this.options = options.options || [];
      this.pattern = options.pattern || '';
      this.input_type = options.input_type || 'text';
      this.maxDate =  this.maxDate || new Date();

    }
  }